// import { canUseDOM } from 'exenv';

export function companyPageLoading(resp = {}, store = {}) {
  return {
    type: 'COMPANY_PAGE_LOADING',
    companyPage: resp,
    store
  };
}

export function companyPageLoaded(resp = {}, store = {}) {
  return {
    type: 'COMPANY_PAGE_LOADED',
    companyPage: resp,
    store
  };
}

export function companyPageLoadError(error, store = {}) {
  return {
    type: 'COMPANY_PAGE_ERROR',
    companyPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
